import { Box, Text } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type { WizardStepProps } from 'modules/engagement_surveys/components/SurveyWizard/types'

export function BasicInfoStep({ data, errors, onDataChanged }: WizardStepProps) {
  return (
    <Box gap="s32">
      <Text.Header2 weight="semibold">
        {i18n.t('surveys.configuration.basic_info.title')}
      </Text.Header2>

      <Box gap="s16">
        <TextField
          label={i18n.t('surveys.configuration.basic_info.name')}
          value={data.title}
          onChange={(value) => onDataChanged({ ...data, title: value })}
          error={errors.title}
        />

        <TextArea
          label={i18n.t('surveys.configuration.basic_info.description')}
          value={data.description}
          onChange={(value) => onDataChanged({ ...data, description: value })}
          error={errors.description}
        />
      </Box>
    </Box>
  )
}
